import { Suspense, lazy } from 'react';
import type { TrendChartProps } from './TrendChart';

/**
 * TrendChart behind a code split.
 *
 * Recharts is ~391 KB raw / ~114 KB gzip — a 67% increase on the rest of the
 * bundle. Importing it eagerly would make every patient download it to reach
 * screens that have no chart on them, on mobile data. Pages render charts
 * through this wrapper so the library arrives only when a chart does.
 *
 * Import this module directly, never through `charts/index.ts`: the barrel
 * re-exports TrendChart eagerly, which would pull Recharts back into the main
 * chunk and silently undo the split.
 */
const TrendChart = lazy(() => import('./TrendChart'));

export const LazyTrendChart: React.FC<TrendChartProps> = props => (
  <Suspense
    fallback={
      <div
        className="chart-loading"
        style={{ height: props.height ?? 240 }}
        role="status"
      >
        Memuat grafik...
      </div>
    }
  >
    <TrendChart {...props} />
  </Suspense>
);

export default LazyTrendChart;
